import db from "@/db";

export default {
  namespaced: true,
  state: {
    betaUser: false,
    displayName: "",
    nickname: "",
  },
  mutations: {
    setProfile(state, profile) {
      Object.keys(profile).forEach((key) => {
        state[key] = profile[key];
      });
    },
  },
  actions: {
    async loadAndListen({ commit }) {
      db.userProfile().onSnapshot((snap) => {
        const profile = snap.data() || {};
        commit("setProfile", profile);
      });
    },
    // TODO - MAKE SURE THEY CAN ONLY UPDATE THE ALLOWED FIELDS ON PROFILE
    // IN OTHER WORDS - PROTECT EVERYTHING EXCEPT FOR XYZ
    // eslint-disable-next-line
    async setProfile({}, profile) {
      try {
        // TODO - SIGNAL SUCCESS
        await db
          .userProfile()
          .set({ ...profile, _updated: new Date() }, { merge: true });
      } catch (e) {
        // TODO - SIGNAL FAILURE
        console.error(e);
      }
    },
    async setNickname({ dispatch }, nickname) {
      // TODO - SIGNAL SUCCESS
      return dispatch("setProfile", { nickname });
    },
  },
};
